<template>
  <div>
    <b-col cols="12" class="p-3 mb-2" style="border:solid 1px #DFDFDF;">
      <div class="text-left">
        <span>
          <b-badge variant="warning">Alert {{(alertIndex+1)}}</b-badge>
        </span>
        <span class="ml-4">
          <strong>{{alert.ent_name}}</strong>
        </span>
        <span class="ml-4">
          <font-awesome-icon :icon="alert.ent_tp == 'O' ? 'building' : 'male' "></font-awesome-icon>
        </span>
        <span class="ml-4">
          RDC CVIP&nbsp;
          <b-badge variant="primary" class="mr-3">{{alert.cvip_code || 'N/A'}}</b-badge>
        </span>
        <span class="ml-4">
          RDC Risk Score&nbsp;
          <b-badge variant="dark" class="mr-3">{{alert.risk_score || 'N/A'}}</b-badge>
        </span>

        <span class="ml-4" v-if="alert.is_pep==1">
          
          <b-badge variant="danger" class="mr-3">PEP</b-badge>
        </span>

        <span class="ml-4" v-for="(category, index) in uniqueCategories" :key="index">
          <b-badge variant="dark" class="mr-3">{{category[0]}}: {{category[1]}}</b-badge>
        </span>

        <span class="ml-4" v-if="!alertCollapse && alertStatus=='pending'">
          <b-badge variant="primary">{{alertStatus}}</b-badge>
        </span>
        <span
          class="ml-4"
          v-if="!alertCollapse && (alertStatus!='pending' && alertStatus!='refer to ethixbase')"
        >
          <b-badge :variant="alertStatus=='negative alert' ? 'success': 'danger'">{{alertStatus}}</b-badge>
        </span>

        <b-button
          @click="alertCollapse = !alertCollapse"
          variant="primary"
          class="float-right"
          size="sm"
        >
          <font-awesome-icon :icon="alertCollapse ? 'minus' : 'plus'" />
        </b-button>
      </div>

      <div class="clearfix"></div>
      <b-collapse id="collapse-2" class="mt-2" v-model="alertCollapse">
        <h3>
          <small>
            <span class="mr-1">
              <b-badge variant="warning">Alert {{(alertIndex+1)}}</b-badge>
            </span>
          </small>
          {{alert.ent_name}}
          <span class="ml-4" v-if="alertStatus=='pending'">
            <small>
              <b-badge variant="primary">{{alertStatus}}</b-badge>
            </small>
          </span>
          <span class="ml-4" v-if="alertStatus!='pending' && alertStatus!='refer to ethixbase'">
            <small>
              <b-badge
                :variant="alertStatus=='negative alert' ? 'success': 'danger'"
              >{{alertStatus}}</b-badge>
            </small>
          </span>
        </h3>

        <b-tabs content-class="mt-3 text-left">
          <b-tab :title="'Remediate Alert '+(alertIndex+1)" active>
            <b-row>
              <b-col cols="6" style="max-height:600px;overflow-y:auto;">
                <b-card no-body>
                  <b-nav pills card-header slot="header" v-b-scrollspy:nav-scroller>
                    <b-nav-item href="#sources" @click="scrollIntoView">Sources</b-nav-item>
                    <b-nav-item href="#sources-info" @click="scrollIntoView">Sources Information</b-nav-item>

                    <b-nav-item href="#aliases" @click="scrollIntoView">Alaises</b-nav-item>
                    <b-nav-item href="#addresses" @click="scrollIntoView">Addresses</b-nav-item>
                    <b-nav-item href="#attributes" @click="scrollIntoView">Attributes</b-nav-item>
                  </b-nav>

                  <b-card-body
                    id="nav-scroller"
                    ref="content"
                    style="position:relative; height:500px; overflow-y:scroll;"
                  >
                    <h4 id="sources">Sources</h4>
                    <b-row>
                      <b-col cols="12">
                        <p>
                          <span>
                            <strong>Source Name:</strong>
                          </span>
                          &nbsp;{{alert.ent_src_name || "Not Available"}}
                        </p>
                        <p>
                          <span>
                            <strong>Source Date:</strong>
                          </span>
                          &nbsp; {{alert.ent_src_publication_date || "Not Available"}}
                        </p>

                        <p>
                          <span>
                            <strong>Source Url:</strong>
                          </span>
                          &nbsp;{{alert.ent_src_url || "Not Available"}}
                        </p>
                      </b-col>
                    </b-row>

                    <h4 id="sources-info">Sources Information</h4>
                    <b-row
                      v-for="(event,eventIndex) in JSON.parse(alert.ent_evnt)"
                      :key="eventIndex"
                    >
                      <b-col cols="12">
                        <p>
                          <span>
                            <strong>Category:</strong>
                          </span>&nbsp;
                          <b-badge
                            :id="'category-tooltip-target-'+eventIndex+'-'+alert.id"
                            variant="primary"
                          >{{event.category || "Not Available"}}</b-badge>
                        </p>
                        <b-tooltip
                          :target="'category-tooltip-target-'+eventIndex+'-'+alert.id"
                        >Catgeory tooltip, need to make this dynamic</b-tooltip>
                        <p>
                          <span>
                            <strong>Description:</strong>
                          </span>&nbsp;
                          <span v-html="sanitizeHtml(event.description || 'Not Available')"></span>
                        </p>
                        <p>
                          <span>
                            <strong>Sub Category:</strong>
                          </span>&nbsp;
                          <b-badge
                            variant="primary"
                            :id="'subcategory-tooltip-target-'+eventIndex+'-'+alert.id"
                          >{{event.subCategory || "Not Available"}}</b-badge>
                        </p>
                        <b-tooltip
                          :target="'subcategory-tooltip-target-'+eventIndex+'-'+alert.id"
                        >Sub Catgeory tooltip, need to make this dynamic</b-tooltip>
                        <hr v-if="alertIndex>0" />
                      </b-col>
                    </b-row>

                    <h4 id="aliases">Aliases</h4>
                    <p v-html="sanitizeHtml(getAlaises(alert.ent_alias))"></p>

                    <h4 id="addresses">Addresses</h4>
                    <p v-html="sanitizeHtml(getAddress(alert.ent_address) || 'No information')"></p>

                    <h4 id="attributes">Attributes</h4>
                    <div
                      v-for="(atribute,atributeIndex) in JSON.parse(alert.ent_attri)"
                      :key="atributeIndex"
                    >
                      <p v-if="atribute.code">
                        <b-badge variant="primary">
                          <span v-html="sanitizeHtml(atribute.code)"></span>
                        </b-badge>
                        : {{atribute.value || 'N/A'}}
                      </p>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col cols="6">
                <b-card header="Remediation status" header-tag="header">
                  <b-row>
                    <b-col cols="12">
                      <b-form-radio-group
                        v-model="alertStatus"
                        @change="onUpdateStatus($event, alert)"
                        :options="remediationOptions"
                        :disabled="reportStatus"
                      ></b-form-radio-group>
                    </b-col>
                    <b-col cols="12">
                      <b-form-group label="Remediation Comments">
                        <b-form-textarea
                          placeholder="Enter something..."
                          rows="3"
                          max-rows="6"
                          required
                          v-model="remedationComment"
                          @blur="updateAlert($event,alert)"
                          :disabled="reportStatus"
                        ></b-form-textarea>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12">
                      <b-form-group
                        label="Action taken to clear/confirm the alerted name(i.e. how)"
                      >
                        <b-form-textarea
                          :placeholder="!reportStatus ? 'Enter your notes and comments' :''"
                          rows="3"
                          max-rows="6"
                          :disabled="reportStatus"
                          required
                          v-model="remedationCommentActionNote"
                          
                        ></b-form-textarea>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12">
                      <h3 v-if="!reportStatus">Upload Supporting documentation</h3>
                      <h3 v-if="reportStatus">Supporting documentation</h3>
                      <vue-dropzone v-if="!reportStatus"
                        ref="myVueDropzone"
                        @vdropzone-success="vsuccess"
                        id="dropzone"
                        :options="dropzoneOptions"
                        :useCustomSlot="true"
                      >
                        <div class="dropzone-custom-content">
                          <h3 class="dropzone-custom-title">Drag and drop to upload content!</h3>
                          <div class="subtitle">...or click to select a file from your computer</div>
                        </div>
                      </vue-dropzone>
                    </b-col>
                    <b-col cols="12">
                      <b-table-simple striped hover>
                        <b-thead>
                          <b-tr>
                            <b-th>fileName</b-th>
                            <b-th>fileType</b-th>
                            <b-th>fileSize</b-th>
                            <b-th v-if="!reportStatus">fileAction</b-th>
                          </b-tr>
                        </b-thead>
                        <b-tbody v-for="(item, index) in files" :key="index">
                          <b-tr>
                            <b-td>{{item.filename}}</b-td>
                            <b-td>{{item.type}}</b-td>
                            <b-td>{{item.size}}</b-td>
                            <b-td v-if="!reportStatus">
                              <b-button
                                @click="onDeleteFile(index, files)"
                                variant="danger"
                                size="sm"
                              >
                                <font-awesome-icon icon="trash" />
                              </b-button>
                            </b-td>
                          </b-tr>
                        </b-tbody>
                      </b-table-simple>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-collapse>
    </b-col>
  </div>
</template>

<script>
import { HTTP } from "../../utils/HTTP";
import { sanitizeHtml } from "@/utils/sanitizeHtml";
import { mapGetters, mapState } from "vuex";
import vue2Dropzone from "../Dropzone/VueDropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import uid from "uid";

export default {
  name: "RDCAlertOgm",
  components: {
    vueDropzone: vue2Dropzone
  },
  data() {
    return {
      alerStatuses: ["pending", "negative alert", "positive alert"],
      remedationComment: null,
      remedationCommentActionNote: null,
      files: [],
      dropzoneOptions: {
        //url: 'https://httpbin.org/post',
        url:
          process.env.VUE_APP_API_URL +
          "v1/uploads/rdc/file/" +
          this.$route.params.id,
        thumbnailWidth: 150,
        maxFilesize: 10,

        //parallelUploads:50,
        // addRemoveLinks: true,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken")
        }
      },

      alertCollapse: false,
      alertStatus: "pending",
      date: null,
      remediationOptions: ["pending", "positive alert", "negative alert"],
      riskCategories: ["REC", "ABC", "CVC"],
      riskSubCatgeories: ["EFG", "HIJ", "LMN", "OPQ", "RST"],
      riskSources: ["RiskConnect", "OFAC", "Factiva", "Bloomsberg"],

      // for ctegories
      uniqueCategories: [],
      uniqueSubCategories: [],
      secUniqueCount: 0
    };
  },
  created() {},
  mounted() {
   
    this.getfiles();
    this.remedationCommentActionNote =
      this.alert.comments.remedationCommentActionNote || null;
    this.remedationComment =
      JSON.parse(this.alert.comments) && JSON.parse(this.alert.comments).remedationComment && JSON.parse(this.alert.comments).remedationComment.comment || null;
    this.alertStatus = this.alerStatuses[this.alert.alert_status] || "Pending";
    //this.getUniqueCategories(this.alert.ent_evnt);
  },
  validations: {},
  computed: {
    ...mapGetters([]),
    ...mapState(["toggleAllCoppalse"])
  },
  watch: {
    toggleAllCoppalse(value) {
      this.collapse = value;
    }
  },
  methods: {
    sanitizeHtml,
    updateAlert(event, alert) {
      let token = "Bearer " + localStorage.getItem("accessToken");
      let postData = {
        alert_status: this.alertStatus,
        rdc_monitoring_entity_report_alert_id: alert.id,
        comment_by_id: localStorage.getItem("userId"),
        remedationComment: this.remedationComment,
        remedationCommentActionNote: this.remedationCommentActionNote
      };

      let result = HTTP(
        "post",
        "v1/remediation/ogm/entity/alert/update",
        postData,
        {
          Authorization: token
        },
        null,
        true
      );
    },
    readableBytes(bytes) {
      var i = Math.floor(Math.log(bytes) / Math.log(1024)),
        sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

      return (bytes / Math.pow(1024, i)).toFixed(2) * 1 + " " + sizes[i];
    },

    vsuccess(file, response) {
      let uploadedFile = {};
      if (response && response.url) {
        uploadedFile = {
          fileId: uid(),
          filename: file.name,
          caption: { english: this.slideCaption },
          text: { english: this.slideText },
          size: file.size,
          type: file.type,
          url: response.url
        };
        this.files.push(uploadedFile);
        this.$refs.myVueDropzone.removeFile(file);
      }
    },

    onDeleteFile(index, files) {
      this.files.splice(index, 1);

      let formData = {
        files: files,
        alertId: this.$route.params.id
      };

      this.totalAlerts = 0;
      let token = "Bearer " + localStorage.getItem("accessToken");
      this.isLoading = true;
      let result = HTTP("post", "v1/uploads/rdc/deletefile", formData, {
        Authorization: token
      });

      return result
        .then(response => {
          const items = response.data.data;
          return items;
        })
        .catch(error => {
          return [];
        });
    },

    async getfiles() {
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        this.isLoading = true;
        let result = await HTTP(
          "get",
          "v1/uploads/rdc/getfiles/" + this.$route.params.id,
          {},
          {
            Authorization: token
          },
          null,
          true
        );
        if (result.data.length > 0) {
          this.files = result.data;
        } else {
          this.files = [];
        }
        this.isLoading = false;
      } catch {
        this.isLoading = false;
      }
    },

    // Convenience method to scroll a heading into view.
    // Not required for scrollspy to work
    scrollIntoView(evt) {
      evt.preventDefault();
      const href = evt.target.getAttribute("href");
      const el = href ? document.querySelector(href) : null;
      if (el) {
        this.$refs.content.scrollTop = el.offsetTop;
      }
    },

    getAlaises(alais) {
      let alaisObject = JSON.parse(alais);
      //let jsn = JSON.parse(alais).aliasName + ',  Type: ' + JSON.parse(alais).aliasType;
      //return jsn.join(", <br />");
      return alaisObject.alaisName + " " + alaisObject.aliasType;
      if (typeof alais === "string") {
        let temp = alais.split(",");
        return temp.join(", <br />");
      } else {
        let jsn =
          JSON.parse(alais).aliasName +
          ",  Type: " +
          JSON.parse(alais).aliasType;
        //return jsn.join(", <br />");
        return jsn;
      }
    },

    getAddress(address) {
      if (typeof address === "string") {
        let temp = address.split(",");
        return temp.join(", <br />");
      } else {
        let jsn = JSON.parse(address);
        return jsn.join(", <br />");
      }
    },

    // for alerts calculations
    onUpdateStatus(status, alert) {
      this.$emit("getStatus", status, alert);
    },
    //-----for categories
    getUniqueCategories(alertEvents) {
      let counts = {};
      JSON.parse(alertEvents).forEach(alert => {
        counts[alert.category] = (counts[alert.category] || 0) + 1;
      });
      this.uniqueCategories = Object.entries(counts);
    }
  },
  props: {
    alert: Object,
    alertIndex: Number,
    reportStatus: Boolean
  }
};
</script>
